export default "__VITE_ASSET__DizWi7ho__"